import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import sanitize from 'sanitize-html';

import { serviceApi } from '~/features';
import type { UpdateCampaignDto, UpdateCampaignModelView } from '~/types';

export const PATCH_CAMPAIGN_MUTATION_KEY = 'PATCH_CAMPAIGN_MUTATION';

async function updateCampaign(body: UpdateCampaignDto) {
  const updatedBody = {
    ...body,
    ...(body.name && { name: sanitize(body.name) }),
    ...(body.appBanners && {
      appBanners: body.appBanners.map(banner => ({
        ...banner,
        projectAdsId: 2,
      })),
    }),
    ...(body.webBanners && {
      webBanners: body.webBanners.map(banner => ({
        ...banner,
        projectAdsId: 2,
      })),
    }),
  };

  return serviceApi.patch<UpdateCampaignModelView>('/Campanha', updatedBody, {
    headers: { 'Content-Type': 'application/json' },
  });
}

export function useUpdateCampaign(
  onSuccess?: (
    data: AxiosResponse<UpdateCampaignModelView, unknown>,
    variables: UpdateCampaignDto,
    context: unknown
  ) => unknown,
  onError?: (
    error: Error,
    variables: UpdateCampaignDto,
    context: unknown
  ) => unknown
) {
  return useMutation({
    mutationKey: [PATCH_CAMPAIGN_MUTATION_KEY],
    mutationFn: async (body: UpdateCampaignDto) => updateCampaign(body),
    onSuccess,
    onError,
  });
}

export type UseUpdateCampaignReturn = ReturnType<typeof useUpdateCampaign>;
